module.exports = __webpack_public_path__ + "static/media/ic_add_lot_hover.4bc20e4a.svg";